<template>
  <div class="Detail">
    <div v-if="initok">
      <div class="watermark">
        <div v-for="i in 15"><span v-for="i in 15" :style="{fontSize: watermarkSize + 'px'}">{{watermark}}</span></div>
      </div>
      <div class="top cf">
        <!-- <div class="fl nav"><router-link to="/Index">首页<i class="iconfont icon-you"></i>{{data.list.Name}}<i class="iconfont icon-you"></i></router-link>{{data.item.Name}}</div> -->
        <router-link to="/Index">
          <div class="fl nav">
            网盘<i class="iconfont icon-you"></i>
            {{data.list.Name}}<i class="iconfont icon-you"></i>
            {{data.item.Name}}
          </div>
        </router-link>
        <div class="fr" v-if="data.item.collected" @click="dealCol(false)">取消收藏</div>
        <div class="fr" v-else @click="dealCol(true)">加入收藏</div>
      </div>
      <div style="padding: 10px;margin-bottom: 20px;line-height: 2.2; position: relative; z-index: 99;" v-html="data.item.Describe"></div>
      <div class="relevant">
        <div class="list cf">
          <router-link to="/Index">
            <div class="jianbian"></div>
            <div class="one" v-for="(item,index) in data.list.items">
              <div class="img"><img :style="{marginTop: item.Icon==1?'10px':'0' , transform: item.Icon==2?'scale(0.7,0.7)':''}" :src="`https://resource.yatiku.com/resources/sendInformation/imgs/img${item.Icon}.png`"  /></div>
              <div class="text">{{item.Name}} </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div v-else><loading></loading></div>
    <alert :con="info"></alert>

    <div class="collected" @click="dialogEwmFlag = true"><a href="javascript:;">下载</a></div>


    <!-- 打开文件状态2 -->
    <div class="lxl-dialog-container" v-if="dialogEwmFlag">
      <div class="lxl-dialog-box">
        <div class="lxl-dialog-bd">
          <img :src="wxcode" alt="">
        </div>
        <div class="lxl-dialog-ft" v-html="dialogEwmText"></div>
        <div class="lxl-dialog-close" @click="dialogEwmFlag = false">
          <i class="iconfont icon-guanbi"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var longPressTimer = null , scrollFn = null , initPromise = null;
import Alert from '@/components/Alert'
import Loading from '@/components/Loading'
import {findId , dealCol} from '@/components/public.js'

export default {
  components: {
    Alert,Loading
  },
  data () {
    return {
      dialogEwmFlag: false,
      wxcode: '',
      dialogEwmText: '',
      data: {},
      info: '',
      initok: false,
      watermark: '',
      watermarkSize: 30
    }
  },
  methods: {
    dealCol () {
      dealCol(this,this.data.item);
    },
    getdata () {
      this.axios.get(
        'http://app.yatiku.com/app/getInformationById',
        {
          params: {
            "Id": this.$route.query.id,
            "catalogId": this.$route.query.CatalogId
          }
        }
      ).then((res) => {
        let ids = (local.getItem('IndexIds')||'').split(',');
        res.data.item.collected = findId(ids,res.data.item.Id)!==false;
        this.data = res.data;
        this.initok = true
      })
    },
    getIndexData () {
      initPromise = new Promise((resolve, reject)=> {
        this.axios.get(
          'http://app.yatiku.com/app/getactivityallsendinformation',
          {params: {catalogId, codeId }}
        ).then((res) => {
            console.log(res.data);
            if (!this.$route.query.title) {
              document.title = res.data.catalogType.Name;
            }
             res.data.catalogType.variable.forEach(item => {
              if (item.watermark) {
                localStorage.setItem('watermark', item.watermark);
              }
              if (item.watermarkSize) {
                localStorage.setItem('watermarkSize', item.watermarkSize);
              }
              if (item.ewmText) {
                localStorage.setItem('ewmText', item.ewmText);
              }
              if (item.ewmSize) {
                localStorage.setItem('ewmSize', item.ewmSize);
              }
            });
            resolve();
        })
      });
    }
  },
  mounted () {
    this.watermark = localStorage.getItem('watermark');
    this.watermarkSize = localStorage.getItem('watermarkSize');
    this.wxcode = localStorage.getItem('wxcode');
    this.dialogEwmText = localStorage.getItem('dialogEwmText');
    document.title = this.$route.query.title;
    share(this.$route.query.id,this.$route.query.CatalogId);
    this.getdata();
    this.getIndexData();
  }
}
</script>

<style lang="less" scoped>


  .Detail{
    padding-top: 44px;
    background: white;
  }
  .watermark{
    overflow: hidden;
    position: fixed;
    z-index: 1;
    transform:rotate(-20deg) translateY(-50%);
    transform-origin: 50% 50%;
    div{
      margin: 40px 0;
      width: 2000px;
      span{
        display: inline-block;
        margin-bottom: 20px;
        margin-right: 100px;
        position: relative;
        font-size: 18px;
        color: rgba(0,0,0,0.1);
      }
    }
  }
  .relevant{
    position: relative;
    z-index: 2;
  }
  .list{
/*    background: rgba(192,192,192,0.4);*/
    padding: 20px;
    margin: 0 10px;
    position: relative;
  }
  .one{
    width: 25%;
    padding: 0 10px;
    display: inline-block;
    vertical-align:top;
    text-align: center;
    margin-bottom: 0px;
    font-size: 12px;
    color: #464646;
    box-sizing: border-box;
    .text{
      transform: scale(0.8,.8)
    }
    .img{
      height: 65px;
      img{
        width: 70%;
        transform-origin: 50% 0;
      }
    }
  }
  .jianbian{
    background: red;
    width: 100%;
    height: 100%;
    z-index: 1000;
    position: absolute;
    top: 0px;
    left: 0px;
    background: linear-gradient(to top, rgba(230,230,230,1),  rgba(230,230,230,0));
  }

  .top{
    border-bottom: 1px solid #ccc;
    z-index: 101;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    width: 100%;
    box-sizing: border-box;
    background: white;
    padding: 10px;
    .nav{
      font-size: 16px;
      width: 70%;
      white-space:nowrap;overflow:hidden;text-overflow:ellipsis; 
      i{
        font-size: 12px;
        margin: 0 5px;
      }
    }
    .fr{
      text-decoration: underline;
      color: #5e6f9b;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Detail.vue